"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcalendarsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcalendarsm` : '') + (description ? ` desc-brandedcalendarsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcalendarsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcalendarsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 17.17V7h20v10.17A1.83 1.83 0 0 1 18.17 19H1.83A1.83 1.83 0 0 1 0 17.17Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m10.32 9.63-.32.31-.32-.31a2.17 2.17 0 0 0-3.45.55l-.04.08a2.1 2.1 0 0 0 .37 2.3l3.24 3.35c.1.12.3.12.4 0l3.18-3.28c.64-.64.8-1.63.4-2.45l-.05-.08a2.16 2.16 0 0 0-3.41-.47Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2H7a2 2 0 1 1-4 0H1.3A1.3 1.3 0 0 0 0 3.3V7h20V3.3A1.3 1.3 0 0 0 18.7 2H17a2 2 0 1 1-4 0Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "4",
    width: "2",
    height: "3",
    rx: "1",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "14",
    width: "2",
    height: "3",
    rx: "1",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = brandedcalendarsm;